module.exports = __webpack_public_path__ + "static/media/pic3.4a822ff3.jpg";